import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { unsafeUseFormReturnSubset } from '@ipfabric/ui-components/utils/formSnippets/unsafeUseFormReturnSubset';
import { DeviceCredentials } from '../../../components/Authentication/DeviceCredentials';
import {
  type DeviceCredentialsFieldValues,
  storedDeviceCredentials,
} from '../../../snippets/storedDeviceCredentials';
import type { DiscoveryConfigWizardGroupDisplayControl } from '../DiscoveryConfigWizardPage1';

export const deviceCredentialsGroup = createFormSnippetGroup({
  snippets: {
    storedDeviceCredentials,
  },
  render: ({ renderSnippet, form }) => (
    <DeviceCredentials
      form={unsafeUseFormReturnSubset(form)<
        keyof DeviceCredentialsFieldValues
      >()}
      renderSnippet={renderSnippet}
    />
  ),
  show: (control: DiscoveryConfigWizardGroupDisplayControl) => {
    control.setAuthenticationSubTab('deviceCredentials');
  },
});
